"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_ATTEMPT_EVENT_TYPES = exports.AUDIT_EXPORT_MAX_ROWS = exports.AUDIT_DEFAULT_WINDOW_DAYS = void 0;
exports.isAccountAttempt = isAccountAttempt;
exports.describeDevice = describeDevice;
// USER-06, the access log (Admin redesign 2026-11-02, Access log A): what one entry carries, and
// the plain device name shown beside its address. Everything is read from the event log.
/** How far back the access log looks when no "When" is given. */
exports.AUDIT_DEFAULT_WINDOW_DAYS = 30;
/** The most rows one export holds; a wider one is refused with "narrow the dates". */
exports.AUDIT_EXPORT_MAX_ROWS = 10_000;
/**
 * Attempts on somebody's account (review R21): whoever typed the password is unknown, so these have
 * no "Done by". They are about the account's owner ("Someone tried to sign in as …"), and "Everything
 * by them" leaves them out.
 */
exports.AUDIT_ATTEMPT_EVENT_TYPES = ['auth.login_failed', 'auth.2fa_failed', 'auth.account_locked'];
function isAccountAttempt(eventType) {
    return exports.AUDIT_ATTEMPT_EVENT_TYPES.includes(eventType);
}
const BROWSERS = [
    [/Edg(?:e|A|iOS)?\//, 'Edge'],
    [/OPR\/|Opera/, 'Opera'],
    [/SamsungBrowser\//, 'Samsung Internet'],
    [/Firefox\/|FxiOS\//, 'Firefox'],
    [/Chrome\/|CriOS\//, 'Chrome'],
    [/Safari\//, 'Safari'],
];
const SYSTEMS = [
    [/Android/, 'Android'],
    [/iPhone|iPad|iPod/, 'iOS'],
    [/Windows/, 'Windows'],
    [/Mac OS X|Macintosh/, 'Mac'],
    [/CrOS/, 'ChromeOS'],
    [/Linux/, 'Linux'],
];
/**
 * "Chrome on Windows" from a browser's user-agent text, for the access log. Null for no text, so
 * the screen shows —; the raw text for one it can't read, so nothing is hidden.
 */
function describeDevice(userAgent) {
    if (!userAgent)
        return null;
    const browser = BROWSERS.find(([pattern]) => pattern.test(userAgent))?.[1];
    const system = SYSTEMS.find(([pattern]) => pattern.test(userAgent))?.[1];
    if (browser && system)
        return `${browser} on ${system}`;
    return browser ?? system ?? userAgent;
}
//# sourceMappingURL=access-log.js.map